module.exports = __webpack_public_path__ + "img/低通锐化1.76a06c5f.png";